const deliveryTime = document.querySelector('.delivery_time');

function deliveryTimeToggle(event) {
  if (event.detail.variant.available == false) {
    deliveryTime.style.display = 'none';
  } else {
    deliveryTime.style.display = 'block';
  }
}

if (deliveryTime) document.addEventListener("variant:change", (event) => deliveryTimeToggle(event));

// toggle best before date badge for products

const bbdBadge = document.querySelectorAll('.variant-picker__option-info .bbd-badge');

function toggleBBDBadge(e) {
  // console.log(e.detail.variant.id)
  bbdBadge.forEach(badge => {
    e.detail.variant.id == badge.getAttribute('data-id') ? badge.removeAttribute('hidden') : badge.setAttribute('hidden', '');
  })
}

if (bbdBadge) document.addEventListener("variant:change", (e) => toggleBBDBadge(e));

// cookie banner
let stopObserver = false;
function updateAnchorHrefs(banner) {
  const anchors = banner.querySelectorAll('a');
  const lang = document.querySelector('html').getAttribute('lang');
  anchors.forEach(anchor => {
    const currentHref = anchor.getAttribute('href');
    if (lang == 'en' && currentHref && !currentHref.startsWith('/en') && !currentHref.includes('http')) {
      anchor.setAttribute('href', '/en' + currentHref);
      stopObserver = true;
    }else if (lang !== 'en'){
      stopObserver = true;
    }
  });
}

function observeForBanner() {
  const documentObserver = new MutationObserver((mutationsList, observer) => {
    mutationsList.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.classList && node.classList.contains('cc-overlay-wrapper')) {
          updateAnchorHrefs(node);
          if(stopObserver) observer.disconnect();
        }
      });
    });
  });

  documentObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

observeForBanner();

